import request from '@/utils/request'



//查询
export function queryPageStatisticsDetail(data) {
  return request({
    url: '/admin/statistics/queryPageStatisticsDetail',
    method: 'post',
    data: data
  })
}

//查询办卡成功率
export function getBuyVipRate(params) {
  return request({
    url: '/admin/statistics/getBuyVipRate',
    method: 'get',
    params: params
  })
}


//查询门店业绩统计
export function getStoreCardPerformance(params) {
  return request({
    url: '/admin/statistics/getStoreCardPerformance',
    method: 'get',
    params: params
  })
}

//查询个人业绩
export function calWorkerSalary(params) {
  return request({
    url: '/admin/salary/cmi/calWorkerSalary',
    method: 'get',
    params: params
  })
}










// WEBPACK FOOTER //
// ./src/api/mkt/MktStatistics.js